import React, { useEffect } from "react";
import "./Projects.css";
import ProCards from "./ProCards";
import NET from "vanta/src/vanta.net";
import Preloader from "./Preloader";

const Projects = () => {
  function print(e) {
    const card1 = document.getElementById("card1");
    const card2 = document.getElementById("card2");
    const card3 = document.getElementById("card3");
    const card4 = document.getElementById("card4");
    const card5 = document.getElementById("card5");

    if (card1 !== null && card2 !== null && card3 !== null && card4 !== null) {
      // console.log("F")
      if (card1.getBoundingClientRect().top <= 100) {
        card1.style.position = "sticky";
        card1.style.top = "100px";
      } else card1.style.position = "static";
      if (card2.getBoundingClientRect().top <= 110) {
        card2.style.position = "sticky";
        card2.style.top = "110px";
      } else card2.style.position = "static";
      if (card3.getBoundingClientRect().top <= 130) {
        card3.style.position = "sticky";
        card3.style.top = "130px";
      } else card3.style.position = "static";
      if (card4.getBoundingClientRect().top <= 140) {
        card4.style.position = "sticky";
        card4.style.top = "140px";
      } else card4.style.position = "static";
      if (card5.getBoundingClientRect().top <= 150) {
        card5.style.position = "sticky";
        card5.style.top = "150px";
      } else card5.style.position = "static";
    }
  }

  useEffect(() => {
    if (document.getElementById("hidden_div") !== null)
      document.getElementById("hidden_div").style.display = "none";
    NET({
      el: "#projectBlock1",
      color: "#ffb703",
      backgroundColor: "#023047",
    });
    setTimeout(() => {
      const PreLoad = document.getElementById("projectPreload");
      if (PreLoad) {
        PreLoad.style.display = "none";
        const body = document.getElementsByTagName("body")[0];
        body.style.overflow = "visible";
      }
    }, 2000);
  });
  return (
    <>
      <Preloader id="projectPreload" />

      <div id="projects" onScroll={print}>
        <div id="projectBlock1">
          <div id="proIntro">
            <div>Projects</div>
          </div>
        </div>

        <div id="projectBlock2">
          <ProCards
            src="keep.png"
            id="card1"
            color="#1679AB"
            text="Google Keep Clone"
            gitLink=""
            liveLink="https://googlekepp.netlify.app/"
            about1="I have made this Google Kepp Clone using Reactjs 
            and in backend I have used MonngoDb as a database.
            In this project I also implemnted Email verification,
            which ensure only valid users."
            about2="This project is live now ,you can visit ."
          />
          <ProCards
            src="attendance.jpeg"
            id="card2"
            color="#C5FF95"
            text="AI Automated Attendance"
            about1="This is an AI Automated Attendance model.
                   This model can be used to take attendance using
                   computer vision and face recoginition technology"
            about2="I have provided the Github link."
          />
          <ProCards
            src="traffic.jpg"
            id="card3"
            color="#5DEBD7"
            text="AI Enabled Traffic Light"
            about1="In this project I have developed smart traffic light
                system which can smartly decide which lane should be allowed 
                to move and which should wait to
                handle traffic more efficiently."
            about2="Tn this project I have used Machine Learning and
            Computer Vision"
          />
          <ProCards
            src="portfolio.jpg"
            id="card4"
            color="#DD5746"
            text="Portfolio"
            gitLink=""
            liveLink="https://pratham1singh.github.io/Weather-app/"
            about1="This is my portfolio website which you are currently seeing."
            about2="I have made this website using Reactjs."
          />
          <ProCards
            src="weather.png"
            id="card5"
            color="#FFC470"
            text="Live Weather App"
            gitLink=""
            liveLink="https://pratham1singh.github.io/Weather-app/"
            about1="In this weather  app you can access real time weather prediction of following seven days."
            about2="This project is live now ,you can visit ."
          />
          <ProCards
            src="rock_paper.png"
            id="card6"
            color="#FFC470"
            text="Rock-Paper-Scissors"
            gitLink=""
            liveLink="https://rock-paper-scissor-108.netlify.app/"
            about1="I hope you will like this, I think you must visit once."
            about2="This project is live now ,you can visit ."
          />
        </div>
      </div>
    </>
  );
};

export default Projects;
